export enum ObjectType {
  Lead = 'Lead',
  Account = 'Account',
  Opportunity = 'Opportunity',
}

export enum DataType {
  Text = 'text',
  YesNo = 'yesno',
  Picklist = 'picklist',
  Currency = 'currency',
  Date = 'date',
  Email = 'email',
  Phone = 'phone',
}

export enum Transform {
  None = 'None',
  PhoneNormalize = 'PhoneNormalize',
  DigitsOnly = 'DigitsOnly',
  DateParse = 'DateParse',
}

export interface SectionConfig {
  id: string
  sectionKey: string
  sectionLabel: string
  objectType: ObjectType
  order: number
  sectionsOrder?: string
  active: boolean
}

export interface FieldMapping {
  id: string
  questionKey: string
  section: string // References SectionKey
  promptText: string
  dataType: DataType
  targetSObject: ObjectType
  targetFieldApiName: string
  positionInSection: number
  required: boolean
  isRequiredForCompletion: boolean
  preferably: boolean
  active: boolean
  conditionKey?: string
  conditionValue?: string
  transform: Transform
}

export interface PicklistOption {
  id: string
  questionKey: string // References FieldMapping questionKey
  optionLabel: string
  optionValue: string
  order: number
  active: boolean
}
